import { render, staticRenderFns } from "./SkupPrijavaDetails.vue?vue&type=template&id=3911f74c&scoped=true&"
import script from "./SkupPrijavaDetails.vue?vue&type=script&lang=js&"
export * from "./SkupPrijavaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911f74c",
  null
  
)

export default component.exports